import moment from 'moment-timezone';
import { get, isEmpty } from 'lodash';
import {
  EXPERTISE_MEDICAL_ID,
  DEFAULT_TYPE_CODE,
  EXPERTISE_ACCOUNTING_ID,
  DOCTOR_RESERVE,
  EXPERT_RESERVE,
} from 'containers/CourtManagerLegalProceedings/constants';
import { CORRECTIONAL_JUDICIARY_PROCESS_ID } from 'containers/LawyerFeeNote/constants';

export const returnDefaultCodeByType = (type: any) => {
  if (Number(type) === EXPERTISE_MEDICAL_ID) {
    return DEFAULT_TYPE_CODE.MEDICAL;
  } else if (Number(type) === EXPERTISE_ACCOUNTING_ID) {
    return DEFAULT_TYPE_CODE.ACCOUNTING;
  } else {
    return DEFAULT_TYPE_CODE.MECHANIC;
  }
};
export const returnReserveCodeByType = (type: any, listings: any) => {
  if (Number(type) === EXPERTISE_MEDICAL_ID) {
    return get(
      get(listings, 'intervenants', []).find(
        (item: any) => item.ItemDescription.trim() === DOCTOR_RESERVE,
      ),
      'ItemKey',
      '',
    );
  } else if (Number(type) === EXPERTISE_ACCOUNTING_ID) {
    return get(
      get(listings, 'intervenants', []).find(
        (item: any) => item.ItemDescription.trim() === EXPERT_RESERVE,
      ),
      'ItemKey',
      '',
    );
  } else {
    return get(
      get(listings, 'intervenants', []).find(
        (item: any) => item.ItemDescription === EXPERT_RESERVE,
      ),
      'ItemKey',
      '',
    );
  }
};
export const filtredNatureProcedure = (
  judiciaryProcess: any,
  claimHasCivilPartyJudiciaryProcess: any,
  listProcedure: any,
) => {
  const judiciaryProcessNatureId = judiciaryProcess.map((el: any) =>
    Number(el.procedureNatureId),
  );
  let filtredListProcedure = listProcedure.filter(
    (item: { id: number; title: string }) =>
      judiciaryProcessNatureId.includes(Number(item.id)),
  );
  if (!get(claimHasCivilPartyJudiciaryProcess, 'hasCivilParty', true)) {
    filtredListProcedure = filtredListProcedure.filter(
      (item: any) => item.id != CORRECTIONAL_JUDICIARY_PROCESS_ID,
    );
  }
  return filtredListProcedure;
};
export const containsAppeal = (
  civilProceeding: any,
  procedureNatureId: any,
  judiciaryProcessId: any,
  claimHasCivilPartyJudiciaryProcess: any,
) => {
  const appealClaimsJug = get(
    claimHasCivilPartyJudiciaryProcess,
    'claimAppealJudgements',
    [],
  );
  if (!isEmpty(appealClaimsJug)) {
    if (Number(procedureNatureId) === CORRECTIONAL_JUDICIARY_PROCESS_ID) {
      const correctionalId = get(
        civilProceeding.find(
          (el: any) =>
            Number(el.procedureNatureId) === CORRECTIONAL_JUDICIARY_PROCESS_ID,
        ),
        'id',
      );
      return !isEmpty(
        appealClaimsJug.filter(
          (item: any) => item.judiciaryProcessId === correctionalId,
        ),
      );
    } else {
      return !isEmpty(
        appealClaimsJug.filter(
          (item: any) =>
            Number(item.judiciaryProcessId) === Number(judiciaryProcessId),
        ),
      );
    }
  } else {
    return !isEmpty(appealClaimsJug);
  }
};
export const extractCourtFileNumber = (
  judiciaryProcess: any,
  judiciaryProccessId: any,
) => {
  return judiciaryProcess.find(
    (element: any) => element.id === Number(judiciaryProccessId),
  )?.courtNumber;
};
export const compareDate = (date: any, date2: any) => {
  return moment(date).diff(date2, 'days');
};
